import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Gallery</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Gallery</li>
                    </ul>
                </div>
            </section>
            <section className="department-one" style={{ marginTop: "-60px" }}>
                <div className="department-one_image" style={{ backgroundImage: 'url(assets/images/background/1.jpg)' }} />
                <div className="auto-container">
                    <div className="sec-title light centered" style={{ marginTop: "-70px" }}>
                        <div className="sec-title_title">Our Gallery</div>
                        <h2 className="sec-title_heading">Our Departments Gallery</h2>
                    </div>
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_4.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInLeft" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_3.webp" alt /></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInUp" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_2.webp" alt /></Link>
                                    </div>
                                </div>
                            </div>

                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_5.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_8.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_7.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/img_01.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/img_02.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/img_03.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/img_04.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/img_05.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Gallery